<template>
    <div>
      <Dialog title="选择卡券" :hide="editHide" @handleClick="changeClose">
        <div slot="header">选择卡券</div>
        <div slot="body">
          <div class="journalBody">
            <el-row>
                <el-col v-for="(item,index) in availableArray" :key="index" :span="12" class="contentView flex-row">
                    <div class="write-img">
                        <img :src="leftImg">
                        <div class="leftImgs">
                            <div class="writeLogLabel">¥ {{ item.couponAmount }}</div>
                            <div class="writeLogContentLabel">满{{ item.useLimitAmount }}元可用</div>
                        </div>
                    </div>
                    <div class="read-img" @click="cheakAction(index,item)">
                        <div class="orangeView">
                            <img :src="rightImg">
                        </div>
                        <div class="rightImgs">
                            <div class="c111 f16 ml10 mt10">{{ item.couponName }}</div>
                            <div class="color666 f12 ml10 mt20">失效时间：{{ item.validDateStr }}</div>
                            <div class="itemAvater">
                              <img class="avater-img" src="../../../assets/images/money/coupon_checked.png" alt="" v-if="item.isSelected">
                              <img class="avater-img" src="../../../assets/images/money/coupon_noraml_check.png" alt="" v-else>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="ml10 pb10 pt10" v-if="unAvailableArray.length>0">不可用券({{unAvailableArray.length}})</div>
            <el-row v-if="unAvailableArray.length>0">
                <el-col v-for="(item,index) in unAvailableArray" :key="index" :span="12" class="contentView">
                    <div class="invalidView">
                      <div class="flex-row">
                        <div class="write-img">
                          <img :src="invalidLeftImg">
                          <div class="leftImgs">
                              <div class="writeLogLabel">¥ {{ item.couponAmount }}</div>
                              <div class="writeLogContentLabel">满{{ item.useLimitAmount }}元可用</div>
                          </div>
                        </div>
                        <div class="read-img">
                            <div class="orangeView">
                                <img :src="invalidRightImg">
                            </div>
                            <div class="rightImgs">
                                <div class="c111 f16 ml10 mt10 opacity">{{ item.couponName }}</div>
                                <div class="color666 f12 ml10 mt20 opacity">失效时间：{{ item.validDateStr }}</div>
                                <div class="itemAvater">
                                  <img class="avater-img" src="../../../assets/images/money/coupon_unNormal_check.png" alt="">
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="bgView f12 ml5 mt5 mr10">
                        <div class="remindView">
                            <img :src="remindImg">
                        </div>
                        <span class="reasonView">不可用原因：</span>
                        <span class="reasonValueView">{{ item.notAvailableReason }}</span>
                      </div>
                    </div>
                </el-col>
            </el-row>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="cancelAciton">取 消</el-button>
          <el-button type="primary" @click="trueAction">确 定</el-button>
        </div>
      </Dialog>
    </div>
</template>
  
<script>
import minxin from "../../../assets/javascript/minxin.js";
import Dialog from "../../../components/common/dialog.vue";
export default {
    data() {
      return {
        editHide: false,
        params:{
        },
        availableArray: [],
        unAvailableArray: [],
        selectedItem:{},
        selectedIndex:-1,
        couponSendRecordId:"",
        leftImg: require("../../../assets/images/money/coupon_couponleft.png"),
        rightImg: require("../../../assets/images/money/coupon_couponright.png"),
        invalidLeftImg: require("../../../assets/images/money/invalid_gray.png"),
        invalidRightImg: require("../../../assets/images/money/coupon_couponright_shixiao.png"),
        remindImg: require("../../../assets/images/money/coupon_remind.png"),
        checkedImg: require("../../../assets/images/money/coupon_checked.png"),
      };
    },
    mixins: [minxin],
    components:{Dialog},
    created(){
        this.init();
    },
    methods: {
      init(){
          this.$on('set', function (org) {
              this.editHide = true;
              
              console.log(111111,org);
              this.params.memberId = org.memberId;
              this.params.realPayAmount = org.realPayAmount;
              this.params.orderItemList = org.orderItemList;
              this.couponSendRecordId = org.couponSendRecordId;

              this.couponList();
          });
        },
        couponList() {
        this.$api.post(this.$url.coupon.list, this.params).then((res) => {
          if (res) {
            res.map((item) => {
                item.isSelected = false;
                if (item.availableFlag) {
                  if (item.id == this.couponSendRecordId) {
                    item.isSelected = true;
                  }else {
                    item.isSelected = false;
                  }
                  this.availableArray.push(item)
                }else {
                  this.unAvailableArray.push(item)
                }
            })
        }
      })
      },
      changeClose(show){
          this.editHide = false;
          this.params.memberId = "";
          this.params.realPayAmount = 0;
          this.params.orderItemList = [];
          this.availableArray = [];
          this.unAvailableArray = [];
          this.selectedIndex = -1;
          this.selectedItem = {};
          this.couponSendRecordId = '';
      },
      cancelAciton() {
        this.editHide = false;
        this.params.memberId = "";
        this.params.realPayAmount = 0;
        this.params.orderItemList = [];
        this.availableArray = [];
        this.unAvailableArray = [];
        this.selectedIndex = -1;
        this.selectedItem = {};
        this.couponSendRecordId = '';
      },
      cheakAction(index,item) {
        if (item.isSelected) {
          
        }else {
          this.availableArray.map((indexItem) => {
            indexItem.isSelected = false;
          });
        }
        item.isSelected = !item.isSelected;
        if (item.isSelected) {
          this.selectedIndex = index;
          this.selectedItem = item;
        }else {
          this.selectedIndex = -1;
          this.selectedItem = {};
        };
        this.availableArray[index] = item;
      },
      trueAction() {
          if (this.couponSendRecordId) {
            
          }else {
            if (this.selectedIndex == -1) {
              return this.$message.error('请选择优惠券')
            }
          }
          this.$emit("selectCouponChange", this.selectedItem);
          this.editHide = false;
          this.params.memberId = "";
          this.params.realPayAmount = 0;
          this.params.orderItemList = [];
          this.availableArray = [];
          this.unAvailableArray = [];
          this.selectedIndex = -1;
          this.selectedItem = {};
          this.couponSendRecordId = '';
      },
    }
  }
</script>

  <style scoped lang="less">
  
  /deep/ .el-dialog {
    margin-top: 0 !important;
    height: 600px;
    top: calc(50% - 300px);
    border-radius: 10px;
  }
  
  /deep/ .el-dialog__body {
    padding: 0 !important;
    .bodys {
      box-sizing: border-box;
      padding: 24px 0;
      height: 475px;
      background-color: #F3F4F6;
    }
  }
  
  .journalBody {

    position: relative;
    height: 100%;
    // background-color: #fff;

    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .down-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .down-img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .journaltitle {
    font-size: 19px;
    font-weight: bold;
    color: #111;
    margin-bottom: 15px;
  }
  
  .time {
    margin-top: 7.5px;
    font-size: 12px;
    color: #999;
  }
  
  .mains {
    margin-top: 32px;
    margin-left: 40px;
  }
  .f16 {
    font-size: 16px;
  }

  .invalidView {
    // position: relative;
    // width: 100px;
    height: 130px;
    background-color: #FFFBEC;
    border-radius: 8px;
  }

  .contentView {
      // color: #666;
    //   margin-top: 0px;
    //   margin-bottom: 0;
    //   margin-left: 0;
    //   margin-right: 10;
      padding: 5px;
    }

  .write-img {
    position: relative;
    // width: 100px;
    height: 85px;
    margin-right: 0px;
    img {
      width: 100%;
      height: 85px;
    }
  }
  .read-img {
    position: relative;
    // width: 300px;
    height: 85px;
    margin-right: 0px;
  }
  .orangeView {
    height: 85px;
    img {
      width: 100%;
      height: 85px;
    }
  }
  
  .leftImgs {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      z-index: 99;
    }

    .rightImgs {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 99;
    }

    .writeLogLabel {
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      margin-top: 15px;
      text-align: center;
    }
    .writeLogContentLabel {
      color: #fff;
      font-size: 12px;
      font-weight: bold;
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      margin-top: 5px;
      text-align: center;
    }
  
    .itemAvater {
        position: absolute;
        bottom: 20px;
        right: 10px;
        width: 20px;
        height: 20px;
    }

  .itemAvater img {
      width: 20px;
      height: 20px;
    }

    .bgView {
      // position: relative;
      // width: 300px;
      height: 45px;
      display: flex;
      // align-items: flex-start;
    }

    .reasonView {
      width: 80px;
    }
    .reasonValueView {
      width: 205px;
    }

    .remindView {
      margin-top: 2px;
      margin-right: 2px;
    height: 13px;
    width: 13px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  
  </style>
  